var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.999,
    height: 22,
    viewBox: "0 0 21.999 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1f3f93",
    d: "M20.793 8.611l-1.723-.219a8.663 8.663 0 0 0-.522-1.259l1.064-1.37a1.363 1.363 0 0 0-.112-1.815L18.056 2.5a1.366 1.366 0 0 0-1.82-.116l-1.368 1.068a8.631 8.631 0 0 0-1.26-.522l-.219-1.72A1.373 1.373 0 0 0 12.027 0H9.973a1.373 1.373 0 0 0-1.362 1.207l-.219 1.724a8.531 8.531 0 0 0-1.26.522l-1.37-1.065a1.364 1.364 0 0 0-1.814.112L2.5 3.943a1.367 1.367 0 0 0-.116 1.82l1.068 1.37a8.562 8.562 0 0 0-.522 1.259l-1.72.219A1.373 1.373 0 0 0 0 9.973v2.053a1.373 1.373 0 0 0 1.207 1.362l1.723.219a8.662 8.662 0 0 0 .522 1.259l-1.064 1.37a1.363 1.363 0 0 0 .112 1.816L3.943 19.5a1.367 1.367 0 0 0 1.82.115l1.369-1.064a8.463 8.463 0 0 0 1.259.522l.219 1.72A1.373 1.373 0 0 0 9.973 22h2.053a1.373 1.373 0 0 0 1.362-1.207l.219-1.723a8.662 8.662 0 0 0 1.259-.522l1.37 1.064a1.363 1.363 0 0 0 1.814-.112l1.45-1.444a1.365 1.365 0 0 0 .116-1.82l-1.064-1.369a8.463 8.463 0 0 0 .522-1.259l1.72-.219A1.373 1.373 0 0 0 22 12.027V9.973a1.371 1.371 0 0 0-1.206-1.362zM11 15.583A4.583 4.583 0 1 1 15.583 11 4.588 4.588 0 0 1 11 15.583z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.8cb6437782bd883f0e0ef3cbcaaf1ef7.svg";
export { ForwardRef as ReactComponent };